import { useEffect, useState, useRef } from "react";
import { State, City } from "country-state-city";
import { useForm, SubmitHandler, set } from "react-hook-form";
import AddCentreForm from "../components/centres/CentreForm";
import AddFilterForm from "../components/centres/FilterForm";
import TableHeader from "../components/common/MagicTableHeader";
import Header from "../components/common/MagicPageHeader";
import Table from "../components/common/MagicTable";
import Button from "../components/mui/Button";
import Text from "../components/mui/Text";
import Dialog from "../components/common/Dialog";
import ImageComponent from "../components/mui/Image";
// Actions
import {
  useCreateCentreMutation,
  useFetchedCentreQuery,
  useFetchRegionQuery,
  useFetchedFunderQuery,
  useFetchedProgramTypesQuery,
  useLazyDownloadQuery,
  useUserListQuery,
  useCenterListQuery,
  useUpdateCenterMutation,
  useUpdateCenterStatusMutation,
  useLazyDownloadFetchListQuery,
} from "../store/apis/centerApis";
import dayjs from "dayjs";
import MagicDrawer from "../components/common/MagicDrawer_new";
import ImportCenterContent from "../components/centres/ImportCenterContent";
import ToggleButton from "../components/mui/ToggleButton";
import DownloadToXlsxFile from "../helper/DownloadToXlsxFile";
import Stack from "../components/mui/Stack";
import { useDispatch } from "react-redux";
import { setApiLoading } from "../store/slices/userSlice";
import { showToast } from "../helper/toaster";
import usePermission from "../helper/usePermission";
import { acl } from "../helper/userAccessConstant";

interface CentreFormInterface {
  centreDetail: {
    [key: string]: string | number | null | boolean;
  };
}
interface programType {
  label: string;
  id: number;
}
interface IndianCity {
  label: string;
  id: string;
}

type Cities = IndianCity[];

const selectOptions = {
  district: [{ label: "district1", id: "Brooklyn" }],
  regionalDirector: [{ label: "regionalDirector1", id: 1 }],
  cityManager: [{ label: "cityManager1", id: 1 }],
  centre: [{ label: "cityManager1", id: "kdksfkh" }],
  districtLevelManger: [{ label: "districtLevelManger1", id: 1 }],
  clusterManager: [{ label: "clusterManager1", id: 1 }],
  regionalDataManger: [{ label: "regionalDataManger1", id: 1 }],
  placementHead: [{ label: "placementHead1", id: 1 }],
};
const mcpCentre = [
  { label: "Yes", id: true },
  { label: "No", id: false },
];

const CentresContainers = () => {
  const initialFilterState = {
    region: [],
    centerId: null,
    centerType: null,
    state: null,
    district: null,
    city: null,
    regionalDirector: null,
    cityManager: null,
    districtLevelManager: null,
    clusterManager: null,
    placementHead: null,
    funderId: null,
    genderType: null,
    centerBusinessType: null,
    regionalDataManager: null,
    mcpCentre: null,
    programType: null,
    programSubType: null,
    tenureStartDate: null,
    tenureEndDate: null,
    status: null,
    pageNo: "1",
    pageSize: "10",
    centerManagerData: null,
    biometricCenters: null,
  };
  const dispatch = useDispatch();

  const { permissions } = usePermission();

  const { canRead, canWrite, canUpdate, canDelete } =
    permissions[acl.centres.module]?.module;

  const [importFileModal, setImportFileModal] = useState<boolean>(false);
  const [isOpenAddCentreSidebar, setIsOpenAddCentreSidebar] =
    useState<boolean>(false);
  const [isOpenAddFilterSidebar, setIsOpenAddFilterSidebar] =
    useState<boolean>(false);
  const [isOpenEditCentreSidebar, setIsOpenEditCentreSidebar] =
    useState<boolean>(false);
  const [params, setParams] = useState<{
    [key: string]: number | string | undefined;
  }>({});

  const [cities, setCities] = useState<Cities>([]);

  const indianStates: { label: string; id: string }[] =
    State.getStatesOfCountry("IN")?.map((state: any) => ({
      label: state.name,
      id: state.isoCode,
    })) || [];

  const [isLessThen3Value, setIsLessThen3Value] = useState<boolean>(false);
  // Use useRef to persist the timeout ID across renders

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [filter, setFilter] = useState<any>({ ...initialFilterState });

  const [searchValue, setSearchValue] = useState("");

  const [importConfirmationModal, setImportConfirmationModal] = useState(false);

  // Actions:
  const [createCenter, { isLoading: isCreatingLoading }] =
    useCreateCentreMutation();
  const {
    data: fetchedCentre = { allCentres: [], totalCentres: 0 },
    isLoading: isLoadingCenters,
    refetch: centerRefetch,
  } = useFetchedCentreQuery(params);

  // console.log({fetchedCentre})

  const downloadPayload = {
    ...params,
    pageNo: "1",
    pageSize: fetchedCentre.totalCentres,
  };

  // const {
  //   data: downloadData = { allCentres: [], totalCentres: 0 },
  //   isLoading: downloadLoading,
  //   refetch: centerRefetchDownload,
  // } = useDownloadFetchListQuery(downloadPayload);

  const [
    downloadCenterData,
    {
      data: downloadData = { allCentres: [], totalCentres: 0 },
      isLoading: downloadLoading,
    },
  ] = useLazyDownloadFetchListQuery();

  const { data: fetchedRegion = [] } = useFetchRegionQuery();
  const { data: fetchedFunder = [] } = useFetchedFunderQuery();
  const { data: fetchedProgramTypes = {} } = useFetchedProgramTypesQuery();
  const { data: centerList = {} , refetch : centerListRefetch } = useCenterListQuery({
    state: filter.state ? filter?.state?.label : undefined,
    district: filter.district ? filter?.district?.label : undefined,
    region: filter.region ? filter?.region : undefined,
    pageNo: "1",
    pageSize:"10000"
  }, { refetchOnMountOrArgChange: true } );
  const [centerUpdateAction, { isLoading: isLoadingUpdateCenter }] =
    useUpdateCenterMutation({});

  const [updateCenterStatus] = useUpdateCenterStatusMutation();
  // Calling same api for different use roles
  const { data: regionalDirector = [], isLoading: isLoadingRegionalDirector } =
    useUserListQuery({ roleId: "3" });

  const { data: nationalDirector = [], isLoading: isLoadingNationalDirector } =
    useUserListQuery({ roleId: "2" });
  const { data: centerManagerOptions = [], isLoading: isLoadingCenterManager } =
    useUserListQuery({ roleId: "6" });

  const { data: cityManager = [], isLoading: isLoadingCityManger } =
    useUserListQuery({ roleId: "4" });
  const {
    data: districtLevelManager = [],
    isLoading: isLoadingDisLevelManager,
  } = useUserListQuery({ roleId: "12" });
  const { data: clusterManager = [], isLoading: isLoadingClusterManager } =
    useUserListQuery({ roleId: "5" });
  const {
    data: regionalDataManager = [],
    isLoading: isLoadingRegionalDataManager,
  } = useUserListQuery({ roleId: "9" });
  const { data: placementHead = [], isLoading: isLoadingPlacementHead } =
    useUserListQuery({ roleId: "8" });

  // @ts-ignore
  const totalCenters = fetchedCentre.totalCentres;
  const totalPages = Number(Math.ceil(Number(totalCenters) / 10));

  const handleEditBtnClick = (data: any) => {
  
    let prepareformData: any = { ...data }; // <-- Using spread syntax to create a shallow copy

    let selectedRegion: any = fetchedRegion.find(
      (item: any) => item?.label === data?.region
    ) || null;
    prepareformData.regionId = selectedRegion?.id || null;

    const selectedRegionalDirector: any = data?.regionalDirectors?.length ?  regionalDirector.find(
      (item) => item?.label === data?.regionalDirectors
    ) : null;

    const selectedNationalDirector: any = data?.nationalDirectors?.map(
      (item: any) => ({
        label: item.username,
        id: item.userId,
      })
    ) || null;

    prepareformData.nationalSrDirector = selectedNationalDirector[0] || null; // Prefill nationalDirector

    prepareformData.regionalDirector = selectedRegionalDirector || null;

    prepareformData.genderType = data?.genderType;

    const selectedCityManager: any = cityManager.find(
      (item) => item.label === data.cityManager
    ) || null;
    prepareformData.cityManager = selectedCityManager?.id ? selectedCityManager : null;

    const selectedDLM: any = districtLevelManager.find(
      (item) => item.label === data.districtLevelManager
    ) || null;
    prepareformData.selectedDLM = selectedDLM?.id ? selectedDLM : null;

    const selectedCM: any = clusterManager.find(
      (item) => item.label === data.clusterManager
    ) || null;
    prepareformData.clusterManager = selectedCM?.id ? selectedCM : null;

    const selectedFunder: any = fetchedFunder.find(
      (item) => item.label === data.funder
    ) || null;
    prepareformData.funder = selectedFunder?.id ? selectedFunder : null;

    const selectedRDM: any = regionalDataManager.find(
      (item) => item.label === data.regionalDataManager
    ) || null;
    prepareformData.regionalDataManager = selectedRDM?.id ? selectedRDM : null;

    const selectedPH: any = placementHead.find(
      (item) => item?.label === data?.placementHead
    ) || null;
    prepareformData.placementHead = selectedPH?.id ? selectedPH : null;

    const tenureStartDate = dayjs(data.tenureStartDate).format("DD/MM/YYYY");
    prepareformData.startDate = tenureStartDate || null;

    const tenureEndDate = dayjs(data.tenureEndDate).format("DD/MM/YYYY");
    prepareformData.endDate = tenureEndDate || null;

    const mcpCenter: any = mcpCentre.find((item) => item.id === data.mcpCenter) || null;
    prepareformData.mcpCenter =
      mcpCenter !== null
        ? mcpCenter == 1
          ? { label: "Yes", id: true }
          : { label: "No", id: false }
        : false;

    // @ts-ignore
    const selectedPT: any = fetchedProgramTypes.programTypes.find(
      (item: programType) => item.label === data.programType
    ) || null;
    prepareformData.programType = selectedPT || null;

    // @ts-ignore
    const selectedPST: any = fetchedProgramTypes.programSubTypes.find(
      (item: any) => item.label === data.programSubType
    ) || null;
    prepareformData.programSubTypes = selectedPST || null;


    setCenterForm(prepareformData);

    setIsOpenEditCentreSidebar((prevState) => !prevState);
  };


  const setCenterForm = (data: any = {}, getForm: boolean = false) => {
    // const nationalFormatLabelId = data?.nationalDirectors?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));
    // const regionFormatLabelId = data?.regionalDirectors?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));
    // const regionDataManager = data?.regionalDataManagers?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));
    // const cityManager = data?.cityManagers?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));
    // const clusterManagerLabelId = data?.clusterManagers?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));
    // const crmPlacementHeads = data?.placementHeads?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));
    // const districtLevelManagerLabelId = data?.districtLevelManagers?.map(
    //   (item: any) => ({
    //     label: item?.username,
    //     id: item?.userId,
    //   })
    // );
    // const centermanagerData = data?.centerManagers?.map((item: any) => ({
    //   label: item?.username,
    //   id: item?.userId,
    // }));

    const nationalFormatLabelId = data?.nationalDirectors?.length > 0
      ? {
          label: data.nationalDirectors[0]?.username,
          id: data.nationalDirectors[0]?.userId,
        }
      : null;

    const regionFormatLabelId = data?.regionalDirectors?.length > 0
      ? {
          label: data.regionalDirectors[0]?.username,
          id: data.regionalDirectors[0]?.userId,
        }
      : null;

    const regionDataManager = data?.regionalDataManagers?.length > 0
      ? {
          label: data.regionalDataManagers[0]?.username,
          id: data.regionalDataManagers[0]?.userId,
        }
      : null;

    const cityManager = data?.cityManagers?.length > 0
      ? {
          label: data.cityManagers[0]?.username,
          id: data.cityManagers[0]?.userId,
        }
      : null;

    const clusterManagerLabelId = data?.clusterManagers?.length > 0
      ? {
          label: data.clusterManagers[0]?.username,
          id: data.clusterManagers[0]?.userId,
        }
      : null;

    const crmPlacementHeads = data?.placementHeads?.length > 0
      ? {
          label: data.placementHeads[0]?.username,
          id: data.placementHeads[0]?.userId,
        }
      : null;

    const districtLevelManagerLabelId = data?.districtLevelManagers?.length > 0
      ? {
          label: data.districtLevelManagers[0]?.username,
          id: data.districtLevelManagers[0]?.userId,
        }
      : null;

    const centermanagerData = data?.centerManagers?.length > 0
      ? {
          label: data.centerManagers[0]?.username,
          id: data.centerManagers[0]?.userId,
        }
      : null;

    const centreDetail: any = {
      centerId: data.id || null,
      centerName: data.centerName || null,
      centerType: data.centerType || null,
      projectCode: data.projectCode || null,
      region: data.regionId || null,
      state: data.state || null,
      district: data.district || null,
      city: data.city || null,
      regionalDirector: regionFormatLabelId || null,
      cityManager: cityManager || null,
      districtLevelManager: districtLevelManagerLabelId || null,
      clusterManager: clusterManagerLabelId || null,
      funderId:
        (data?.funderName &&
          data?.funderId && { label: data.funderName, id: data.funderId }) ||
        null,
      regionalDataManager: regionDataManager || null,
      placementHead: crmPlacementHeads || null,
      tenureStartDate: data.startDate || null,
      tenureEndDate: data.endDate || null,
      mcpCenter:
        data?.mcpCenter != null
          ? data.mcpCenter == 1
            ? { label: "Yes", id: true }
            : { label: "No", id: false }
          : null,
      programType: data.programType || null,
      programSubType: data.programSubTypes || null,
      genderType: data?.genderType || null,
      centerBusinessType: data?.centerBusinessType || null,
      centerStatus: data?.centerStatus || null,
      biometricCenters: data.biometricCenters || null,
      isActive: data?.isActive != null ? (data.isActive == 1 ? 1 : 2) : false,
      nationalSrDirector: nationalFormatLabelId || null,
      centerManager: centermanagerData || null,
    };
    if (getForm) {
      return { centreDetail: centreDetail };
    }
    setCenterFormValue("centreDetail", centreDetail);
  };

  const {
    handleSubmit: handleCentreFromSubmit,
    control: centreControl,
    formState: { errors: centreErrors },
    reset: resetCentre,
    getValues: getCenterFormValues,
    setValue: setCenterFormValue,
    watch: watchCenterForm,
  } = useForm<CentreFormInterface>({
    defaultValues: setCenterForm({}, true),
  });

  const toggleAddCentreSidebar = () =>
    setIsOpenAddCentreSidebar((prevState) => !prevState);
  const toggleEditCentreDetailSidebar = () => {
    resetCentre();
    setIsOpenEditCentreSidebar((prevState) => !prevState);
  };
  const handleAddCentreCancelBtn = () => {
    resetCentre();
    setIsOpenAddCentreSidebar((prevState) => !prevState);
  };
  const handleEditCentreCancelAllBtn = () => {
    resetCentre();
    setIsOpenEditCentreSidebar((prevState) => !prevState);
  };

  const toggleAddFilterSidebar = () => {
    setIsOpenAddFilterSidebar((prevState) => !prevState);
  };

  const handleAddFilterClearAllBtn = () => {
    setFilter({ ...initialFilterState });
    setParams({
      search: searchValue === "" ? undefined : searchValue,
      pageNo: "1",
      pageSize: "10",
    });
    // setIsOpenAddFilterSidebar(!isOpenAddFilterSidebar);
  };


  const handleAddCentreDoneBtn: SubmitHandler<any> = async (data) => {
    try {
      const formData: any = data.centreDetail;

      // // Extract cityManager ids from the array of objects
      // const formattedCityManager =
      //   formData.cityManager?.map((item: any) => item.id) || [];
      // // Extract ids for regionalDirector, clusterManager, regionalDataManager, and placementHead
      // const formattedRegionalDirector =
      //   formData.regionalDirector?.map((item: any) => item.id) || [];
      // const formattedClusterManager =
      //   formData.clusterManager?.map((item: any) => item.id) || [];
      // const formattedRegionalDataManager =
      //   formData.regionalDataManager?.map((item: any) => item.id) || [];
      // const formattedNationalDirector =
      //   formData.nationalSrDirector?.map((item: any) => item.id) || [];
      // const formattedDistrictLevelManager =
      //   formData.districtLevelManager?.map((item: any) => item.id) || [];
      // const formattedPlacementHead =
      //   formData.placementHead?.map((item: any) => item.id) || [];
      // const formattedIsActive =
      //   formData.isActive !== null && formData.isActive !== undefined
      //     ? formData.isActive == 1
      //       ? true
      //       : false
      //     : null;
      // const centermanagerData = formData?.centerManager?.map(
      //   (item: any) => item?.id
      // );

      // Extract cityManager ids from the array of objects
      const formattedCityManager = formData.cityManager?.id
        ? [formData.cityManager.id]
        : [];
      // Extract ids for regionalDirector, clusterManager, regionalDataManager, and placementHead
      const formattedRegionalDirector = formData.regionalDirector?.id
        ? [formData.regionalDirector.id]
        : [];
      const formattedClusterManager = formData.clusterManager?.id
        ? [formData.clusterManager.id]
        : [];
      const formattedRegionalDataManager = formData.regionalDataManager?.id
        ? [formData.regionalDataManager.id]
        : [];
      const formattedNationalDirector = formData.nationalSrDirector?.id
        ? [formData.nationalSrDirector.id]
        : [];
      const formattedDistrictLevelManager = formData.districtLevelManager?.id
        ? [formData.districtLevelManager.id]
        : [];
      const formattedPlacementHead = formData.placementHead?.id
        ? [formData.placementHead.id]
        : [];
      const formattedIsActive =
        formData.isActive !== null && formData.isActive !== undefined
          ? formData.isActive == 1
            ? true
            : false
          : false;
      const centermanagerData = formData?.centerManager?.id
        ? [formData?.centerManager.id]
        : [];

      // Construct the payload

      const biometricCenter = (() => {
        if (Array.isArray(formData?.biometricCenters)) {
          return formData.biometricCenters;
        }

        if (formData.biometricCenters.length) {
          return formData.biometricCenters;
        }
      })();

      const payload = {
        centerName: formData.centerName,
        genderType: formData.genderType,
        region: formData.region,
        state: formData.state || null,
        isActive: formattedIsActive || false,
        district: formData.district || null,
        city: formData.district || "",
        centerStatus: formData.centerStatus || null,
        mcpCenter: formData.mcpCenter.id || false,
        centerBusinessType: formData.centerBusinessType || null,
        programType: formData.programType.id || null,
        regionalDirector: formattedRegionalDirector,
        cityManager: formattedCityManager,
        // districtLevelManager: formattedDistrictLevelManager || null,
        clusterManager: formattedClusterManager,
        regionalDataManager: formattedRegionalDataManager,
        placementHead: formattedPlacementHead,
        nationalDirector: formattedNationalDirector || null,
        funderId: formData.funderId?.id || null,
        biometricCenter: biometricCenter || null,
        centerManager: centermanagerData || null,
      };

      // @ts-ignore
      const res: any = await createCenter(payload);
      showToast(res?.data?.message);
      // Handle the response and reset state if successful
      if (res) {
        if (!res.error) {
          resetCentre();
          setIsOpenAddCentreSidebar((prevState) => !prevState);
        }
      }
    } catch (e) {
      console.log("eAdd", e);
    }
  };

  const preparePayload = (filter: any) => {
    const {
      region,
      centerId,
      centerType,
      state,
      district,
      city,
      regionalDirector,
      cityManager,
      districtLevelManager,
      clusterManager,
      placementHead,
      funderId,
      regionalDataManager,
      mcpCenter,
      programType,
      programSubType,
      tenureStartDate,
      tenureEndDate,
      status,
      centerStatus,
      nationalDirector,
      placement,
      centerManagerData,
      centerBusinessType,
      genderType,
    } = filter;

    const payload: any = {
      pageNo: "1",
      pageSize: "10",
      region: region.length > 0 ? region : undefined,
      search: searchValue === "" ? undefined : searchValue,
      centerId: centerId?.id == "" ? undefined : centerId?.id,
      centerType: centerType == "" ? undefined : centerType,
      state: state?.label == "" ? undefined : state?.label,
      centerStatus: centerStatus?.id == "" ? undefined : centerStatus?.id,
      district: district == "" ? undefined : district?.label,
      // city: city,
      regionalDirector:
        regionalDirector?.id == "" ? undefined : regionalDirector?.id,
      centerManager:
        centerManagerData?.id == "" ? undefined : centerManagerData?.id,
      cityManager: cityManager?.id == "" ? undefined : cityManager?.id,
      districtLevelManager:
        districtLevelManager == "" ? undefined : districtLevelManager,
      clusterManager: clusterManager?.id == "" ? undefined : clusterManager?.id,
      // placementHead: placementHead,
      funderId: funderId == "" ? undefined : funderId,
      regionalDataManager:
        regionalDataManager?.id == "" ? undefined : regionalDataManager?.id,
      mcpCenter: mcpCenter?.label === "Yes" ? true : false,
      programType: programType?.id == "" ? undefined : programType?.id,
      placementHead: placement?.id == "" ? undefined : placement?.id,
      nationalDirector:
        nationalDirector?.id == "" ? undefined : nationalDirector?.id,
      programSubType: programSubType == "" ? undefined : programSubType,
      tenureStartDate: tenureStartDate == "" ? undefined : tenureStartDate,
      tenureEndDate: tenureEndDate == "" ? undefined : tenureEndDate,
      centerBusinessType:
        centerBusinessType == "" ? undefined : centerBusinessType,
      genderType: genderType == "" ? undefined : genderType,
      isActive:
        status !== null && status?.length > 0 ? status.join(",") : undefined,
    };

    return payload;
  };

  const handleAddFilterApplyBtn = async () => {
    try {
      setParams(preparePayload(filter));
      setIsOpenAddFilterSidebar((prevState) => !prevState);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleFilterFormChange = (name: string, value: any) => {
    if (name === "state") {
      const indianCities: IndianCity[] = value?.id
        ? City.getCitiesOfState("IN", value?.id).map((city) => ({
            label: city.name,
            id: city.name,
          }))
        : [];
      setCities(indianCities);
    }
    setFilter((prevState:any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const handleFilterRegionSelect = (value: string) => {
  //   setFilter((prevState: any) => {
  //     const newRegions = prevState.region.includes(value)
  //       ? prevState.region.filter((region: string) => region !== value) // Deselect
  //       : [...prevState.region, value]; // Select

  //     return {
  //       ...prevState,
  //       region: [...newRegions], // Update the region array
  //     };
  //   });
  // };

  const handleFilterRegionSelect = (value: string) => {
    setFilter((prevState: any) => ({
      ...prevState,
      region: prevState.region === value ? "" : value, // Allow deselecting by clicking again
    }));
  };

  const handleEditCentreDetailDoneBtn: SubmitHandler<
    CentreFormInterface
  > = async (data) => {
    const formData: any = data.centreDetail;

    // Utility function to extract IDs
    const extractIds = (field: any): any[] => {
      if (Array.isArray(field)) {
        return field.map((item: any) => item.id); // If it's already an array, map through it
      } else if (field && field.id) {
        return [field.id]; // If it's a single object, return its ID wrapped in an array
      }
      return []; // Return an empty array if it's not an array or object with an id
    };

    // Extracting the fields and formatting them
    // const formattedCityManager = extractIds(formData.cityManager);
    // const formattedClusterManager = extractIds(formData.clusterManager);
    // const formattedRegionalDataManager = extractIds(
    //   formData.regionalDataManager
    // );
    // const formattedPlacementHead = extractIds(formData.placementHead);
    // const formattedRegionalDirector = extractIds(formData.regionalDirector);
    // const formattedCenterManager = extractIds(formData.centerManager);

    const formattedCityManager = formData?.cityManager?.id
      ? [formData.cityManager.id]
      : [];
    const formattedClusterManager = formData?.clusterManager?.id
      ? [formData.clusterManager.id]
      : [];
    const formattedRegionalDataManager = formData?.regionalDataManager?.id
      ? [formData.regionalDataManager.id]
      : [];
    const formattedPlacementHead = formData?.placementHead?.id
      ? [formData.placementHead.id]
      : [];
    const formattedRegionalDirector = formData?.regionalDirector?.id
      ? [formData.regionalDirector.id]
      : [];
    const formattedCenterManager = formData?.centerManager?.id
      ? [formData.centerManager.id]
      : [];

    // Additional fields (for mcpCenter and isActive)

    const formattedIsActive = formData.isActive == 1 ? true : false;

    const payload = {
      centerName: formData.centerName,
      genderType: formData.genderType,
      region: formData.region || null,
      state: formData.state || null,
      isActive: formattedIsActive || false,
      district: formData.district || null,
      city: formData.city || null,
      centerStatus: formData.centerStatus || null,
      mcpCenter: formData.mcpCenter === 1 ? true : false, // Ensure mcpCenter is correctly formatted
      centerBusinessType: formData.centerBusinessType || null,
      regionalDirector: formattedRegionalDirector, // Always an array of IDs
      cityManager: formattedCityManager, // Always an array of IDs
      clusterManager: formattedClusterManager, // Always an array of IDs
      regionalDataManager: formattedRegionalDataManager, // Always an array of IDs
      placementHead: formattedPlacementHead, // Always an array of IDs
      nationalDirector: extractIds(formData.nationalSrDirector), // Handle nationalSrDirector as well
      funderId: formData.funderId?.id || null, // Extract funderId.id
      programType: formData.programType?.id || null, // Extract programType.id
      biometricCenter: formData.biometricCenters || null, // Handle biometricCenter, ensure it's an array if present
      centerManager: formattedCenterManager, // Always an array of IDs
    };

    const centerId = getCenterFormValues("centreDetail.centerId");

    // @ts-ignore
    const res = await centerUpdateAction({ centerId, payload });
    showToast(res?.data?.message);

    if (!res.error) {
      resetCentre();
      setIsOpenEditCentreSidebar((prevState) => !prevState);
    }
  };

  const handleImport = () => {
    setImportFileModal(true);
  };

  const handleDialogClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    setImportFileModal(false);
  };

  const handleDownload = async () => {
    const downloadData: any = await downloadCenterData(downloadPayload);
    try {
      const formatList = (list: any[], key: string) =>
        (list || []).map((item) => item[key]).join(" / ") || "";

      const sheetData = [
        [
          "Region",
          "#",
          "SC Centre Name",
          "Biometric device id",
          "Status",
          "Funder",
          "District",
          "State",
          "Gender Type",
          "Centre Business Type",
          "Physical/Virtual Status",
          "Program Type",
          "MCP Centre",
          "National Director",
          "National Director Email",
          "Regional Director",
          "Regional Director Email",
          "City Manager",
          "City Manager Email",
          "Cluster Manager",
          "Cluster Manager Email",
          "Centre Manager",
          "Centre Manager Email",
          "CRM/SPOC",
          "CRM/SPOC Email",
          "Regional Data Manager",
          "Regional Data Manager Email",
        ],
        ...(downloadData?.data?.allCentres?.map((center: any) => [
          center.region || "",
          center.id || "",
          center.centerName || "",
          formatList(center.biometricCenters, "biometricDeviceId"),
          center.status === 1 ? "Active" : "Inactive",
          center.funderName || "",
          center.district || "",
          center.state || "",
          center.genderType || "",
          center.centerBusinessType || "",
          center.centerStatus || "",
          center.programType || "",
          center.mcpCenter || "",
          formatList(center.nationalDirectors, "username"),
          formatList(center.nationalDirectors, "email"),
          formatList(center.regionalDirectors, "username"),
          formatList(center.regionalDirectors, "email"),
          formatList(center.cityManagers, "username"),
          formatList(center.cityManagers, "email"),
          formatList(center.clusterManagers, "username"),
          formatList(center.clusterManagers, "email"),
          formatList(center.centerManagers, "username"),
          formatList(center.centerManagers, "email"),
          formatList(center.placementHeads, "username"),
          formatList(center.placementHeads, "email"),
          formatList(center.regionalDataManagers, "username"),
          formatList(center.regionalDataManagers, "email"),
        ]) || []),
      ];

      DownloadToXlsxFile({ fileNamePrifix: "center-management", sheetData });
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleStateSelect = (stateId: string) => {
    const indianCities = stateId
      ? City.getCitiesOfState("IN", stateId).map((city: any) => ({
          label: city.name,
          id: city.name,
        }))
      : [];

    setCities(indianCities);
  };

  const handleToggle = (rowData: any) => {
    dispatch(setApiLoading(true));
    const updatedStatus = rowData.isActive === 1 ? false : true;
    const centerId = rowData.id;
    const payload = {
      isActive: updatedStatus,
    };

    try {
      updateCenterStatus({ centerId, payload });
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleDistrictSelect = (district: string) => {};

  const handleCenterSearch = (value: string | number) => {
    const searchValue = value.toString();
    const isLessThan3 = searchValue.length > 0 && searchValue.length < 3;
    setIsLessThen3Value(isLessThan3);
    setSearchValue(searchValue);

    // Clear the previous timeout to reset the timer if the user is typing quickly
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Only set params after 1.5 seconds of no new typing
    timeoutRef.current = setTimeout(() => {
      if (searchValue.length >= 3) {
        setParams({ search: searchValue, pageNo: "1", pageSize: "10" });
      } else if (searchValue.length === 0) {
        setParams({
          pageNo: "1",
          pageSize: "10",
        });
      }
    }, 1500); // 1.5 seconds delay
  };
  const handleFinalImport = () => {
    setImportConfirmationModal(true); // Open the success modal
    setImportFileModal(false);
    setTimeout(() => {
      setImportConfirmationModal(false); // Automatically close it after 5 seconds
    }, 5000);
  };
  const onPageChange = async (event: any, page: number) => {
    setParams((prevParams) => ({
      ...prevParams,
      pageSize: "10",
      pageNo: page.toString(),
    }));
  };

  // button of page header
  const buttons = [
    {
      text: "Export",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/exportIcon.svg"
          alt="AddIcon"
        />
      ),
      onClick: handleDownload,
      loading: downloadLoading,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD", // Corrected here
        borderRadius: "8px",
        color: "black",
      },
    },

    {
      text: "Import",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/importIcon.svg"
          alt="ImportIcon"
        />
      ),
      onClick: handleImport,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD", // Corrected here
        borderRadius: "8px",
        color: "black",
      },
    },
    {
      text: "Add Centre",
      variant: "outlined",
      startIcon: (
        <ImageComponent src="/assets/images/login/addIcon.svg" alt="AddIcon" />
      ),
      onClick: toggleAddCentreSidebar,
      sx: {
        border: "1px solid #997906", // Corrected here
        borderRadius: "8px",
        backgroundColor: "#FFF1B7",
        color: "black",
      },
    },
  ];

  // table header buttons
  const tableHeaderBtn = [
    {
      text: "Add filter",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/addFilterIcon.svg"
          alt="AddFilterIcon"
        />
      ),
      onClick: toggleAddFilterSidebar,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD", // Corrected here
        borderRadius: "8px",
        color: "black",
      },
    },
  ];

  // columns for table

  const columns = [
    {
      field: "region",
      headerName: "Region",
      width: 100,
    },
    {
      field: "id",
      headerName: "#",
      width: 50,
      sorting: true,
      renderCell: (params: any) => {
        return params.row.id;
      },
    },
    {
      field: "centerName",
      headerName: "SC Centre Name",
      minWidth: 250,
    },
    {
      field: "biometricCenters",
      headerName: "Biometric device id",
      minWidth: 250,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.biometricCenters?.length > 0 ? (
                params?.row?.biometricCenters?.map((item: any) => (
                  <Text
                    key={item}
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {item.biometricDeviceId}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      minWidth: 100,
      renderCell: (params: any) => {
        return (
          <>
            <ToggleButton
              disabled={!canUpdate}
              sx={{
                "& .MuiSwitch-track": {
                  backgroundColor: params.row.isActive
                    ? "#17A03B !important"
                    : "#A03717 !important",
                },
              }}
              checked={params.row.isActive}
              onChange={() => handleToggle(params.row)}
            />
            {/* </div> */}
          </>
        );
      },
    },
    {
      field: "funderName",
      headerName: "Funder",
      minWidth: 150,
    },
    {
      field: "district",
      headerName: "District",
      minWidth: 100,
    },
    {
      field: "state",
      headerName: "State",
      minWidth: 150,
    },
    {
      field: "genderType",
      headerName: "Gender Type",
      minWidth: 200,
    },
    {
      field: "centerBusinessType",
      headerName: "Center Business Type",
      minWidth: 200,
    },
    {
      field: "centerStatus",
      headerName: "Physical/Virtual Status",
      minWidth: 200,
    },
    {
      field: "programType",
      headerName: "Program Type",
      minWidth: 200,
    },
    {
      field: "mcpCenter",
      headerName: "MCP Centre",
      minWidth: 150,
    },
    {
      field: "nationalUserName",
      headerName: "National Sr. Director",
      minWidth: 150,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.nationalDirectors?.length > 0 ? (
                params.row?.nationalDirectors?.map(
                  (director: any, index: number) => (
                    <Text
                      key={index} // Adding a key to avoid React warnings
                      sx={{
                        border: "1px solid #FEF7DA",
                        background: "#FEF7DA",
                        padding: "0px 10px",
                        borderRadius: "20px",
                        height: "fit-content",
                        fontSize: "14px",
                      }}
                    >
                      {director.username}
                    </Text>
                  )
                )
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "nationalDirectoeEmailId",
      headerName: "National Director Email id",
      minWidth: 150,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.nationalDirectors?.length > 0 ? (
                params?.row?.nationalDirectors?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "regionalDirector",
      headerName: "Regional Director",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.regionalDirectors?.length > 0 ? (
                params?.row?.regionalDirectors?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.username}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "regionalDirectorEmail",
      headerName: "RD email id",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.regionalDirectors?.length > 0 ? (
                params?.row?.regionalDirectors?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },

    {
      field: "cityManager",
      headerName: "City manager",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.cityManagers?.length > 0 ? (
                params?.row?.cityManagers?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.username}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "cityManagerEmail",
      headerName: "CM email id",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.cityManagers?.length > 0 ? (
                params?.row?.cityManagers?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },

    {
      field: "clusterManager",
      headerName: "Cluster Manager",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.clusterManagers?.length > 0 ? (
                params?.row?.clusterManagers?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.username}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "clusterManagerEmail",
      headerName: "Cluster manager email id",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.clusterManagers?.length > 0 ? (
                params?.row?.clusterManagers?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}{" "}
            </Stack>
          </>
        );
      },
    },
    {
      field: "centerManager",
      headerName: "Centre Manager",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.centerManagers?.length > 0 ? (
                params?.row?.centerManagers?.map((manager: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {manager.username}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "centerManagerEmail",
      headerName: "Centre Manager Email ID",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.centerManagers?.length > 0 ? (
                params?.row?.centerManagers?.map((manager: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {manager.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },

    {
      field: "districtLevelManager",
      headerName: "CRM/SPOC",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.placementHeads?.length > 0 ? (
                params?.row?.placementHeads?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.username}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "districtLevelManagerEmail",
      headerName: "CRM/SPOC email id",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.placementHeads?.length > 0 ? (
                params?.row?.placementHeads?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },

    {
      field: "regionalDataManager",
      headerName: "Regional Data Manager",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.regionalDataManagers?.length > 0 ? (
                params?.row?.regionalDataManagers?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.username}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      field: "regionalDataManagerEmail",
      headerName: "RDM Email id",
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <>
            <Stack
              direction="row"
              gap="5px"
              sx={{
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              {params?.row?.regionalDataManagers?.length > 0 ? (
                params?.row?.regionalDataManagers?.map((director: any) => (
                  <Text
                    sx={{
                      border: "1px solid #FEF7DA",
                      background: "#FEF7DA",
                      padding: "0px 10px",
                      borderRadius: "20px",
                      height: "fit-content",
                      fontSize: "14px",
                    }}
                  >
                    {director.email}
                  </Text>
                ))
              ) : (
                <Text>-</Text>
              )}
            </Stack>
          </>
        );
      },
    },
    // {
    //   field: "placementHead",
    //   headerName: "Placement Head",
    //   minWidth: 200,
    //   renderCell: (params: any) => {
    //     return (
    //       <>
    //         <Stack
    //           direction="row"
    //           gap="5px"
    //           sx={{
    //             height: "auto",
    //             overflowY: "auto",
    //             "&::-webkit-scrollbar": {
    //               width: "8px",
    //               height: "2px",
    //             },
    //             "&::-webkit-scrollbar-track": {
    //               background: "#f1f1f1",
    //             },
    //             "&::-webkit-scrollbar-thumb": {
    //               background: "#888",
    //               borderRadius: "10px",
    //             },
    //             "&::-webkit-scrollbar-thumb:hover": {
    //               background: "#555",
    //             },
    //           }}
    //         >
    //           {params?.row?.placementHeads?.length > 0 ? (
    //             <Text>
    //               {params?.row?.placementHeads?.map(
    //                 (director: any) => `${director.username} `
    //               )}
    //             </Text>
    //           ) : (
    //             <Text>-</Text>
    //           )}
    //         </Stack>
    //       </>
    //     );
    //   },
    // },
    // {
    //   field: "projectCode",
    //   headerName: "Project Code",
    //   minWidth: 100,
    // },
    // {
    //   field: "tenure",
    //   headerName: "Tenure",
    //   minWidth: 190,
    // },
    // {
    //   field: "programSubType",
    //   headerName: "Program Sub Type",
    //   minWidth: 250,
    // },

    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      sortable: false,
      renderCell: (props: { row: any }) => {
        return (
          <Button
            variant="contained"
            disabled={!canUpdate}
            sx={{
              textTransform: "capitalize",
              border: "1px solid #997906",
              borderRadius: "8px",
              backgroundColor: "#FFF1B7",
              color: "black",
              boxShadow: "none !important",
            }}
            onClick={() => {
              handleEditBtnClick(props.row);
            }}
          >
            Edit
          </Button>
        );
      },
    },
  ];
  const centerFormStates = getCenterFormValues("centreDetail");
  return (
    <>
      <Header
        title="All centres"
        subTitle="Here you can view the list of all centres."
        chipLabel={`${totalCenters} Centres`}
        buttons={canWrite ? buttons : []}
      />

      <TableHeader
        buttons={tableHeaderBtn}
        onSearchfieldChange={handleCenterSearch}
        isInvalidSearch={isLessThen3Value}
        searchTitle="Search by centre name"
      />

      <Table
        columns={columns}
        // @ts-ignore
        rows={fetchedCentre.allCentres}
        count={totalPages}
        rowCellsSx={{ paddingLeft: "16px", textAlign: "start" }}
        headerSx={{
          paddingLeft: "16px",
          textAlign: "start",
          fontWeight: 600,
          color: "#242424",
          padding: "13px 16px",
        }}
        tableSx={{ minHeight: "300px", width: "100%" }}
        handlePageChange={onPageChange}
        loading={isLoadingCenters}
        sx={{
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#DADADA",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 550,
            fontSize: "14px",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
        }}
        currentPage={Number(params?.pageNo) || 1}
      />

      {/* Add Centre form  MagicDrawer*/}
      <MagicDrawer
        title="Add Centres"
        subtitle="Here you can Add Centre by filling the details"
        drawerOpen={isOpenAddCentreSidebar}
        onDrawerToggle={handleAddCentreCancelBtn}
        actionComponent={() => (
          <>
            <Button
              className="bun-outline"
              onClick={handleAddCentreCancelBtn}
              disabled={isCreatingLoading}
            >
              Cancel
            </Button>
            <Button
              className="bun-filled"
              onClick={handleCentreFromSubmit(handleAddCentreDoneBtn)}
              loading={isCreatingLoading}
              disabled={isCreatingLoading}
            >
              Done
            </Button>
          </>
        )}
      >
        <AddCentreForm
          centerFormStates={centerFormStates}
          control={centreControl}
          errors={centreErrors}
          centerList={centerList}
          regionalDirector={regionalDirector}
          nationalSrDirector={nationalDirector}
          placementHead={placementHead}
          regionalDataManager={regionalDataManager}
          clusterManager={clusterManager}
          districtLevelManager={districtLevelManager}
          cityManager={cityManager}
          centerManager={centerManagerOptions}
          isLoadingPlacementHead={isLoadingPlacementHead}
          isLoadingRegionalDataManager={isLoadingRegionalDataManager}
          isLoadingClusterManager={isLoadingClusterManager}
          isLoadingDisLevelManager={isLoadingDisLevelManager}
          isLoadingCityManger={isLoadingCityManger}
          isLoadingRegionalDirector={isLoadingRegionalDirector}
          // @ts-ignore
          regions={fetchedRegion}
          funder={fetchedFunder}
          states={indianStates}
          cities={cities}
          mcpCentre={mcpCentre}
          handleStateSelect={handleStateSelect}
          handleDistrictSelect={handleDistrictSelect}
          // @ts-ignore
          programTypes={fetchedProgramTypes.programTypes}
          // @ts-ignore
          programSubTypes={fetchedProgramTypes.programSubTypes}
        />
      </MagicDrawer>

      {/* Add Filter form MagicDrawer*/}

      <MagicDrawer
        title="Add filter"
        subtitle="Here you can Add filter by filling the details"
        drawerOpen={isOpenAddFilterSidebar}
        onDrawerToggle={toggleAddFilterSidebar}
        actionComponent={() => (
          <>
            <Button
              className="bun-outline"
              onClick={handleAddFilterClearAllBtn}
              disabled={isLoadingCenters}
            >
              Clear All
            </Button>
            <Button
              className="bun-filled"
              onClick={handleAddFilterApplyBtn}
              loading={isLoadingCenters}
            >
              Apply
            </Button>
          </>
        )}
      >
        <AddFilterForm
          districtLevelManager={districtLevelManager}
          regionalDataManager={regionalDataManager}
          regionalDirector={regionalDirector}
          placementHead={placementHead}
          clusterManager={clusterManager}
          cityManager={cityManager}
          regions={fetchedRegion}
          centerList={centerList}
          funder={fetchedFunder}
          mcpCentre={mcpCentre}
          states={indianStates}
          nationalDirector={nationalDirector}
          filter={filter}
          cities={cities}
          centerManager={centerManagerOptions}
          isLoadingRegionalDataManager={isLoadingRegionalDataManager}
          isLoadingDisLevelManager={isLoadingDisLevelManager}
          isLoadingRegionalDirector={isLoadingRegionalDirector}
          isLoadingClusterManager={isLoadingClusterManager}
          isLoadingPlacementHead={isLoadingPlacementHead}
          isLoadingCityManger={isLoadingCityManger}
          handleFilterRegionSelect={handleFilterRegionSelect}
          handleFilterFormChange={handleFilterFormChange}
          // @ts-ignore
          programTypes={fetchedProgramTypes.programTypes}
          // @ts-ignore
          programSubTypes={fetchedProgramTypes.programSubTypes}
        />
      </MagicDrawer>

      {/* Edit centre details form MagicDrawer */}
      <MagicDrawer
        title="Edit details"
        subtitle="Here you can edit centre details"
        drawerOpen={isOpenEditCentreSidebar}
        onDrawerToggle={handleEditCentreCancelAllBtn}
        actionComponent={() => (
          <>
            <Button
              className="bun-outline"
              onClick={handleEditCentreCancelAllBtn}
              disabled={isLoadingUpdateCenter}
            >
              Cancel
            </Button>
            <Button
              className="bun-filled"
              onClick={handleCentreFromSubmit(handleEditCentreDetailDoneBtn)}
              loading={isLoadingUpdateCenter}
              disabled={isLoadingUpdateCenter}
            >
              Done
            </Button>
          </>
        )}
      >
        <AddCentreForm
          centerFormStates={centerFormStates}
          control={centreControl}
          errors={centreErrors}
          centerList={centerList}
          regionalDirector={regionalDirector}
          placementHead={placementHead}
          nationalSrDirector={nationalDirector}
          regionalDataManager={regionalDataManager}
          // clusterManager={clusterManager}
          clusterManager={clusterManager}
          districtLevelManager={districtLevelManager}
          cityManager={cityManager}
          centerManager={centerManagerOptions}
          isLoadingPlacementHead={isLoadingPlacementHead}
          isLoadingRegionalDataManager={isLoadingRegionalDataManager}
          isLoadingClusterManager={isLoadingClusterManager}
          isLoadingDisLevelManager={isLoadingDisLevelManager}
          isLoadingCityManger={isLoadingCityManger}
          isLoadingRegionalDirector={isLoadingRegionalDirector}
          // @ts-ignore
          selectOptions={selectOptions}
          regions={fetchedRegion}
          funder={fetchedFunder}
          states={indianStates}
          cities={cities}
          mcpCentre={mcpCentre}
          handleStateSelect={handleStateSelect}
          handleDistrictSelect={handleDistrictSelect}
          // @ts-ignore
          programTypes={fetchedProgramTypes.programTypes}
          // @ts-ignore
          programSubTypes={fetchedProgramTypes.programSubTypes}
          biometricData={[]}
        />
      </MagicDrawer>

      <Dialog
        open={importFileModal}
        onOpen={() => {}}
        onClose={handleDialogClose}
        maxWidth="sm"
        disabledBackdropClick={true}
      >
        <ImportCenterContent
          onClose={handleDialogClose}
          onSuccess={handleFinalImport}
        />
      </Dialog>

      <Dialog
        open={importConfirmationModal}
        onOpen={() => {}}
        onClose={() => {
          setImportConfirmationModal(false);
          handleDialogClose("", "backdropClick");
        }}
        maxWidth="sm"
      >
        <div
          style={{
            padding: "40px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {/* Icon Section */}
          <div style={{ marginBottom: "28px" }}>
            <ImageComponent
              sx={{ height: "34px", width: "34px" }}
              src="assets/images/login/SucessfullyImportIcon.svg"
              alt="Successfully Import Icon"
            />
          </div>

          {/* Title Text */}
          <div>
            <text
              style={{ color: "#101828", fontSize: "20px", fontWeight: "600" }}
            >
              The centers list has been successfully uploaded.
            </text>
          </div>

          {/* Description Text */}
          <div>
            <text
              style={{ color: "#667085", fontSize: "14px", fontWeight: "400" }}
            >
              The center list has been uploaded seamlessly, ensuring all data is
              now available for access and review.
            </text>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default CentresContainers;
